import Api from '../api';

export const monitorarCount = async (companyId: number) => {
  const response = await Api.get(`/notification/count_message_not_read`, { params: { companyId } });

  return response?.data;
};
